import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ typography, breakpoints, transitions }) => ({
  imageCard: {
    display: 'flex !important',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 0 !important',
    '& img': {
      width: '50% !important',
    },
  },
}));

export default styles;
